<template>
    <div class="page-content page-content header-clear-medium">

        <div class="card card-style">
            <div class="card-body text-center">
                <h2>{{ title }}</h2>
                <select class="mt-3 form-control w-50 mx-auto" @change="changeBab()">
                    <option v-for="item in kahzanahBab" :key="item.id" v-bind:value="item.id">{{ item.title }}</option>
                </select>
            </div>


            <div class="card card-style">
                <div class="content mb-5">
                    <hr>
                    <div v-for="items in kahzanahBabDetail" :key="items.id">
                        <h3>Bab: {{ items.title }}</h3>
                        <hr>

                        <div v-for="baits in items.bait" :key="baits.id">
                            <div class="d-flex justify-content-between mb-2">
                                <div class="d-flex align-items-center">
                                    <h6 class="mb-0"><span class="border border-dark p-1 px-2">{{ baits.no }}</span></h6>
                                </div>

                                <div class="d-flex align-items-center">
                                    <a href="#" v-if="$store.state.token" class="icon icon-xxs border-highlight border color-highlight rounded-xs me-2"><i class="bi bi-bookmark"></i></a>
                                    <!-- <i class="bi bi-share-fill bg-hi fs-5"></i> -->
                                </div>
                            </div>

                            <div class="row" v-if="terjemahan_kata" dir="rtl">
                                <div class="col-lg-12">
                                    <div v-for="kata in baits.kata" :key="kata.id" class="badge bg-arab float-right m-1">
                                        <h1 class="arab text-dark" v-if="harokat">{{ kata.arab_harokat }}</h1>
                                        <h1 class="arab text-dark" v-if="!harokat">{{ kata.arab }}</h1>
                                        <div v-html="kata.basic_word"></div>
                                        <p class="text-black-50 text-terjemahan teksTerjemah" v-html="kata.indonesia"></p>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="!terjemahan_kata" dir="rtl">
                                <div class="col-lg-12">
                                    <h1 v-if="harokat" class="d-flex flex-wrap mb-2" style="white-space: nowrap;">
                                        <span class="arab" style="padding: 2px;" v-for="kata in baits.kata" :key="kata.id">{{ kata.arab_harokat }}</span>
                                    </h1>
                                    <h1 v-if="!harokat" class="d-flex flex-wrap mb-2" style="white-space: nowrap;">
                                        <span class="arab" style="padding: 2px;" v-for="kata in baits.kata" :key="kata.id">{{ kata.arab }}</span>
                                    </h1>
                                </div>
                            </div>

                            <div v-if="terjemahan_bait" v-html="baits.translate_bait"></div>
                            <div class="d-flex flex-start" v-if="detail">
                                <i class="bi bi-info-circle text-warning me-2"></i><span v-html="baits.description"></span>
                            </div>

                            <hr>
                        </div>

                        <!-- <ol>
                            <hr>
                            <li v-for="baits in items.bait" :key="baits.id" class="py-1">
                                <div dir="rtl">
                                    <h1 class="arab" v-if="harokat">{{ baits.full_bait_harokat }}</h1>
                                    <h1 class="arab" v-if="!harokat">{{ baits.full_bait }}</h1>
                                </div>
                                <div class="row" v-if="terjemahan_kata" dir="rtl">
                                    <div class="col-lg-12">
                                        <div class="badge bg-warning float-right m-1" style="border-radius:30px; padding: 10px" v-for="kata in baits.kata" :key="kata.id">
                                            <h1 class="arab" v-if="harokat">{{ kata.arab_harokat }}</h1>
                                            <h1 class="arab" v-if="!harokat">{{ kata.arab }}</h1>
                                            <div v-html="kata.basic_word"></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="terjemahan_bait" v-html="baits.translate_bait"></div>
                                <div class="d-flex flex-start" v-if="detail">
                                    <i class="bi bi-info-circle text-warning me-2"></i><span v-html="baits.description"></span>
                                </div>
                            </li>
                        </ol> -->
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-evenly align-items-center py-2 paggination">
            <i v-if="prev_page_url" @click="PagginationSurah('prev')" class="bi bi-arrow-left-square-fill fs-5"></i>
            <div class="d-flex align-items-center">
                <h4>Halaman : {{ page }}</h4>
                <a href="#" v-if="$store.state.token" @click="saveBookmarkKhazanahPage()" class="ms-2 icon icon-xxs border-highlight border color-highlight rounded-xs me-2"><i class="bi bi-bookmark"></i></a>
            </div>
            <i v-if="next_page_url" @click="PagginationSurah('next')" class="bi bi-arrow-right-square-fill fs-5"></i>
        </div>

    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: 'Index',
    props: ['title'],
    data(){
        return {
            
        }
    },
    created() {
        this.getKhazanahBab(this.$route.params.id)
        this.getKhazanahBabDetail(this.$route.params.id)
        this.getKhazanahBookmarkBab()
    },
    methods: {
        ...mapActions('khazanahBab', ['getKhazanahBab', 'getKhazanahBabDetail', 'getKhazanahBookmarkBab']),
        ...mapActions('bookmark', ['saveBookmarkPage']),
        changeBab() {
            
        },
        saveBookmarkKhazanahPage() {
            this.saveBookmarkPage({
                'type': 'khazanah',
                'post_id': this.$route.params.id,
                'page': this.page 
            })
        }
    },
    computed: {
        ...mapState('khazanahBab', {
            kahzanahBab: state => state.kahzanahBab,
            kahzanahBabDetail: state => state.kahzanahBabDetail,
            page : state => state.page,
            prev_page_url : state => state.prev_page_url,
            next_page_url : state => state.next_page_url
        }),
        ...mapState([
            'terjemahan_bait', 'terjemahan_kata', 'harokat', 'detail'
        ])
    }
}
</script>

<style scoped>
.page-content {
  padding-bottom: 146px;
}

.paggination {
    position: fixed;
    bottom: 60px;
    /* width: 100%; */
    right: 0;
    left: 0;
    background-color: white;
    border: 1px solid #cecece;
}
.paggination-detached {
    left: 10px !important;
    right: 10px !important;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 25px;
}
</style>